var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "db relative center pt5" }, [
    _c(
      "div",
      { staticClass: "db relative center ph3 ph0-ns mv0" },
      [_c("social-icons")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "db relative center mt3 pv3 footer container-fluid-full-width bb-red"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "flex center mw6 pv4 relative flex-row items-center justify-around"
          },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "db center f6 f5-ns tc ttu is-bebas no-underline pointer is-white",
                attrs: { to: "/contact/" }
              },
              [_vm._v("\n        Contact\n      ")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass:
                  "db center f6 f5-ns tc ttu is-bebas no-underline pointer is-white",
                attrs: { to: "/terms-of-use/" }
              },
              [_vm._v("\n        Terms of Use\n      ")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass:
                  "db center f6 f5-ns tc ttu is-bebas no-underline pointer is-white",
                attrs: { to: "/privacy-policy/" }
              },
              [_vm._v("\n        Privacy Policy\n      ")]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }